import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Cabserviceinmumbai() {



  const cardData = {
    keyword: " Cab Service in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and comfortable cab services in Mumbai, providing safe, affordable, and convenient travel for local rides, airport transfers, and outstation journeys. Whether you are traveling for business, leisure, daily commute, or family trips, our professional drivers and well-maintained vehicles ensure a smooth and stress-free experience across Mumbai and nearby cities. We provide 24/7 cab availability with quick pickup, transparent pricing, and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travel needs. With easy online booking and round-the-clock customer support, Royal Route Cab is your trusted choice for cab service in Mumbai.",

"topPlaces": [
  {
    "title": "Pune",
    "description": "Pune is one of the most popular outstation destinations from Mumbai, known for its historical landmarks, IT hubs, educational institutions, and pleasant weather. It is ideal for business trips, family travel, and weekend getaways."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a scenic hill station located between Mumbai and Pune, famous for its waterfalls, lush green valleys, Tiger Point, and Bhushi Dam. It is a favorite weekend getaway for nature lovers."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station known for its strawberry farms, breathtaking viewpoints, cool climate, and attractions like Venna Lake and Arthur's Seat. It is a popular destination for family vacations and honeymoon trips."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the Shri Sai Baba Temple every year. It is a preferred spiritual trip from Mumbai."
  },
  {
    "title": "Nashik",
    "description": "Nashik is famous for its vineyards, religious temples, and the sacred Godavari River. It is a popular destination for wine tourism, pilgrimages, and weekend road trips from Mumbai."
  },
  {
    "title": "Goa",
    "description": "Goa is a favorite holiday destination from Mumbai, offering beautiful beaches, Portuguese architecture, vibrant nightlife, water sports, and delicious seafood."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is renowned for the UNESCO World Heritage Sites of Ajanta and Ellora Caves, along with Bibi Ka Maqbara. It is a popular historical and cultural destination."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur is known for the Mahalakshmi Temple, traditional cuisine, historical forts, and cultural heritage. It is a popular religious and leisure travel destination."
  },
  {
    "title": "Matheran",
    "description": "Matheran is Asia's only automobile-free hill station, offering peaceful surroundings, panoramic viewpoints, toy train rides, and pleasant weather throughout the year."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town famous for its clean beaches, sea forts, water sports, and relaxing atmosphere, making it one of the most popular weekend destinations near Mumbai."
  }
],






services: [
  {
    name: "Cab Service in Mumbai",
    description: "Cab service in Mumbai offers reliable and convenient transportation for daily travel, airport transfers, and outstation trips. With a wide range of vehicles and professional drivers, this service ensures comfort and safety across the city. Ideal for individuals, families, and business travelers. Flexible booking options and 24x7 availability enhance convenience. It guarantees a smooth and hassle-free travel experience."
  },
  {
    name: "Taxi Service in Mumbai",
    description: "Taxi service in Mumbai provides easy and accessible travel across the city with door-to-door pickup and drop. This service is perfect for daily commuting and local travel needs. Vehicles are well-maintained and driven by experienced chauffeurs. Flexible timing and quick booking options make it highly convenient. It ensures a comfortable journey."
  },
  {
    name: "Car Rental Mumbai",
    description: "Car rental Mumbai offers flexible travel solutions for personal, corporate, and leisure use. Customers can choose from a wide range of vehicles based on their needs. Suitable for hourly, daily, and long-term rentals. Easy booking process and transparent pricing enhance convenience. It ensures a customized and comfortable travel experience."
  },
  {
    name: "Local Cab Service Mumbai",
    description: "Local cab service Mumbai is designed for short-distance travel within the city. This service is ideal for daily commutes, shopping trips, and office travel. Quick availability and flexible booking options make it convenient. Professional drivers ensure safe travel. It guarantees a smooth city travel experience."
  },
  {
    name: "Best Cab Service in Mumbai",
    description: "Best cab service in Mumbai ensures top-quality travel experience with well-maintained vehicles and professional drivers. This service focuses on punctuality, comfort, and customer satisfaction. Suitable for local, airport, and outstation travel. Multiple vehicle options are available. It guarantees a premium and reliable journey."
  },
  {
    name: "Cheap Cab Service Mumbai",
    description: "Cheap cab service Mumbai offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Affordable sedan options are available for daily and short-distance travel. Transparent pricing ensures no hidden charges. It is perfect for economical city travel."
  },
  {
    name: "Online Cab Booking Mumbai",
    description: "Online cab booking Mumbai provides a quick and hassle-free way to reserve your ride. Customers can choose vehicle type, pickup location, and timing easily. Instant confirmation and secure payment options enhance convenience. It ensures availability whenever needed. It simplifies travel planning."
  },
  {
    name: "Mumbai Taxi Booking",
    description: "Mumbai taxi booking allows customers to book taxis easily for local and outstation travel. This service offers flexible options and quick confirmations. Suitable for daily commuting and long-distance trips. Professional drivers ensure safe travel. It ensures a reliable journey."
  },
  {
    name: "Private Cab Service Mumbai",
    description: "Private cab service Mumbai offers a personalized travel experience with exclusive vehicle usage. Travelers can customize routes and travel timings based on their needs. Ideal for families, couples, and business travelers. Comfortable vehicles and professional drivers enhance the experience. It ensures a relaxed journey."
  },
  {
    name: "24 Hours Cab Service Mumbai",
    description: "24 hours cab service Mumbai ensures round-the-clock availability for all travel needs. This service is ideal for late-night travel, early morning airport transfers, and emergency rides. Quick booking and reliable drivers ensure timely service. It guarantees convenience at any time."
  },
  {
    name: "Airport Cab Service Mumbai",
    description: "Airport cab service Mumbai provides seamless pickup and drop to domestic and international terminals. This service ensures timely arrival and departure for flights. Professional drivers and clean vehicles enhance comfort. Suitable for business travelers and tourists. It guarantees a smooth airport transfer."
  },
  {
    name: "Outstation Cab Service Mumbai",
    description: "Outstation cab service Mumbai offers comfortable travel to nearby cities and long-distance destinations. This service is ideal for weekend trips, business travel, and family vacations. Vehicles are maintained for highway travel. Flexible packages include one way and round trips. It ensures a hassle-free journey."
  },
  {
    name: "Luxury Cab Service Mumbai",
    description: "Luxury cab service Mumbai provides premium travel experience with high-end vehicles and professional chauffeurs. This service is ideal for corporate clients, VIP travel, and special occasions. Comfortable interiors and superior service enhance the journey. It ensures a stylish and luxurious ride."
  },
  {
    name: "Corporate Cab Service Mumbai",
    description: "Corporate cab service Mumbai offers professional transport solutions for companies and employees. This service is ideal for office pick-up and drop, business meetings, and corporate travel. Reliable drivers and well-maintained vehicles ensure punctuality. It guarantees efficient and safe corporate travel."
  },
  {
    name: "Sedan Cab Service Mumbai",
    description: "Sedan cab service Mumbai is perfect for individuals and small families seeking affordable and comfortable travel. Sedans offer smooth rides and good mileage for city travel. Ideal for daily commuting and airport transfers. Professional drivers ensure safe travel. It ensures a pleasant journey."
  },
  {
    name: "SUV Cab Service Mumbai",
    description: "SUV cab service Mumbai provides spacious and comfortable travel for families and groups. SUVs offer better performance and extra space for luggage. Suitable for long-distance and city travel. Professional drivers ensure safe journeys. It delivers a comfortable experience."
  },
  {
    name: "Innova Cab Service Mumbai",
    description: "Innova cab service Mumbai is ideal for group travel and corporate trips. The vehicle offers spacious seating and premium comfort for long and short journeys. Suitable for airport transfers and outstation travel. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Ertiga Cab Service Mumbai",
    description: "Ertiga cab service Mumbai is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. Ideal for local and outstation travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  }
],

tableData: [
  ["Cab Service in Mumbai", "Taxi Service in Mumbai"],
  ["Car Rental Mumbai", "Local Cab Service Mumbai"],
  ["Best Cab Service in Mumbai", "Cheap Cab Service Mumbai"],
  ["Online Cab Booking Mumbai", "Mumbai Taxi Booking"],
  ["Private Cab Service Mumbai", "24 Hours Cab Service Mumbai"],
  ["Airport Cab Service Mumbai", "Outstation Cab Service Mumbai"],
  ["Luxury Cab Service Mumbai", "Corporate Cab Service Mumbai"],
  ["Sedan Cab Service Mumbai", "SUV Cab Service Mumbai"],
  ["Innova Cab Service Mumbai", "Ertiga Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service Across Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service in Mumbai for local travel, airport transfers, corporate use, and outstation trips."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in Mumbai city routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing with no hidden costs, ensuring complete fare transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai cab service operates 24/7, allowing you to book rides anytime for daily travel or urgent requirements."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide flexible cab services including local city rides, airport transfers, and outstation travel from Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable service, punctual drivers, and smooth travel experience in Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide cab service in Mumbai?", answer: "Yes, Royal Route Cabs offers reliable cab services across Mumbai for local and outstation travel." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai cab service operates 24/7." },
  { question: "Which areas do you cover in Mumbai?", answer: "We provide cab service across all areas including South Mumbai, Andheri, Borivali, Navi Mumbai, and Thane." },
  { question: "Do you provide airport cab service?", answer: "Yes, we provide airport pickup and drop services from Mumbai Airport (T1 & T2)." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Mumbai to various destinations." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "Cab service in Mumbai with Royal Route Cabs was very smooth and reliable. The booking was quick and the ride experience felt comfortable and safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "Excellent cab service across Mumbai. The driver was punctual, the vehicle was clean, and the overall experience was hassle-free and well-managed.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/cab-service-in-mumbai.jpg", // replace if needed
  "description": "Book reliable cab service in Mumbai with Royal Route Cabs. We offer local, airport, and outstation taxi services with sedan, SUV, Innova, and luxury cars. Available 24x7 for safe, affordable, and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // adjust if needed (base/local cab pricing)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cab-service-in-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Cab Service in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book cab service in Mumbai with Royal Route Cabs. 24x7 local, airport, and outstation taxi service with sedan, SUV, Innova & luxury cars. Safe, affordable & reliable rides."
  />

  <meta
    name="keywords"
    content="cab service in mumbai, taxi service in mumbai, car rental mumbai, local cab service mumbai, best cab service in mumbai, cheap cab service mumbai, online cab booking mumbai, mumbai taxi booking, private cab service mumbai, 24 hours cab service mumbai, airport cab service mumbai, outstation cab service mumbai, luxury cab service mumbai, corporate cab service mumbai, sedan cab service mumbai, suv cab service mumbai, innova cab service mumbai, ertiga cab service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmumbai;